/**
 * 根据模板付费类型及用户会员状态
 * 转换模板的类型显示及使用限制
 */
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            visibleCoupon: false,  // 优惠券弹窗
            payvisible: false, //是否显示支付面板
            currentTemplate: {}, //选中的模板
        };
    },
    components: {
        CouponDialog: () => import("@/platformCode/dialogTicket"),
        // payPanel: () => import("~/components/templates/payPanel"),
        templatePayPanel: () => import("@/components/PayPanel.vue"),
    },
    computed: {
      ...mapGetters(["userInfo", "loginStatus", "isEenterprise", "tmpLevelType", "levelType", ]),
  },
  methods: {
      discountVisible(item) {
          return this.transTempPayTpye(item) === 1 && item.priceOfPromotion;
      },
      /**
       * 未登录的显示状态：免费，价格；
       * 登录后的显示状态：免费，已购买，针对会员的免费+价格；
       * item.payType：0免费  1付费-会员免费  2付费(优惠价) 3付费(折扣) 4企业专属 5:来画币 6.付费-企业会员免费 PS.不过23一直没有用过
       * 返回值：0免费，1原价，2已购买，3会员免费,6 促销模板, 7企业会员免费
       */
      transTempPayTpye(item) {
          if (!this.loginStatus) {
              switch (item.payType) {
                  case 0://免费模板
                      return 0;
                  case 1://付费模板，显示原价
                      if (item.isPromoted) return 6;
                      return 1;
                  case 4://企业会员专属
                      return 1;
                  case 6:
                      return 7;
                  default:
                      return 1;
              }
          } else {
              // 高级体验会员可以使用所有类型模板
              if (item.payType != 0 && this.isEenterprise){
                  return 3;
              }
              switch (item.payType) {
                  case 0:
                      // 免费模板=》免费
                      return 0;
                  case 1:
                  case 2:
                  case 3:
                      //付费模板但已购买=>已购买
                      if (item.tt) {
                          return 2;
                      }
                      //普通用户或者体验会员
                      // else if (this.tmpLevelType || this.levelType == 0) {
                      else if (this.$store.getters["isPoor"]){
                          // 模板促销
                          if (item.isPromoted) return 6;
                          return 1;
                      }
                      else if (this.levelType > 0) {
                          return 3;
                      }
                      break;
                  case 4:
                      if (item.tt) {
                          //付费模板但已购买=>已购买
                          return 2;
                      } else if (this.isEenterprise || this.levelType == 0) {
                          return 1;
                      } else if (this.levelType > 0) {
                          return 3;
                      }
                      break;
                  case 6:
                      //付费模板但已购买=>已购买
                      if (item.tt) {
                          return 2;
                      }
                      // 如果不是企业会员
                      else if (!this.isEenterprise) {
                          // 模板促销
                          if (item.isPromoted) return 6;
                          return 7;
                      }
                      else  {
                          return 0;
                      }
                  default:
                      return 1;
              }
          }
      },
      transPriceType(template){
          let priceType = "";
          let payType = this.transTempPayTpye(template);
          switch (payType) {
              case 0:
                  priceType = "免费";
                  break;
              case 3:
                  priceType = "会员免费";
                  break;
              default:
                  priceType = "";
                  break;
          }
          return priceType;
      },
      /**
       * @param {Object} template 模板数据对象
       * @param {Boolean} replace 是否在当前页面跳转，还是新开一个tab，默认为false新开tab页面
       */
      async operation(template, replace = false) {
          if (!this.loginStatus) {
              if (this.transTempPayTpye(template) == 0) {
                  this.$router.push({ query: { login: true, template: template.checkId} });
                  this.changeLoginVisible(true);
              } else {
                  this.changeLoginVisible(true);
              }
              return;
          }

          // 如果有模板兑换券，直接弹出优惠券弹窗
          let hasUsableCoupon = await this.checkUsableCoupon(6);

          let tempPayTpye = this.transTempPayTpye(template);
          console.log("tempPayTpye:", tempPayTpye);
          // 跳转到工具，使用模板
          let exe = (template, replace) => {
              this.$store.commit("sensors/useTemplate2Sensor", {
                  card: template,
                  source,
              });

              // 神策埋点：立即使用模板
              let source = "";
              const { query, name } = this.$route;
              if (name === "templates") {
                  source = "模板广场";
              } else if (name === "workbench-discover") {
                  source = "工作台发现页";
              }
              if (name === "templates-id") {
                  source = "模板详情页";
              }
              let href =  window.location.origin + `/tool?template=${template.checkId}`;
              // replace ? window.location.href = href : window.open(href);
              replace ? window.location.href = href : openWin(href);
              function openWin(url) {
                let tagA = document.createElement("a");
                tagA.href = url;
                tagA.target = "_blank";
                tagA.click();
                tagA.remove();
            }
          };

          // 高级体验会员可以使用所有类型模板
          if (this.tmpLevelType === 2) {
              exe(template, replace);
              return;
          }

          switch (tempPayTpye) {
              case 4://企业会员专属模板
                  if (this.tmpLevelType) {
                      // hasUsableCoupon ? this.visibleCoupon = true : showPaypanel(template);
                      this.showPaypanel(template, hasUsableCoupon);
                      return;
                  }
                  if (this.levelType == 0) {//用户类型为免费或个人会员或者临时会员
                      this.$confirm("此模板为企业会员专属模板，升级为企业会员后可使用", "提示", {
                          center: true,
                          showCancelButton: false,
                          confirmButtonText: "升级为企业会员",
                          type: "info"
                      }).then(() => {
                          window.open(window.location.origin + "/payment?levelType=1");
                      }).catch(_ => { });
                  } else {
                      this.$message({
                          type: "info",
                          center: true,
                          message: "即将为你打开专属模板。",
                          duration: 1000,
                          onClose: () => {
                              this.$.toToolCollect(template.id, 2, 1, this.userInfo.id);
                              exe(template, replace);
                          }
                      });
                  }
                  break;
              case 1:
              case 5:
              case 6:
                  // hasUsableCoupon ? this.visibleCoupon = true : showPaypanel(template);
                  this.showPaypanel(template, hasUsableCoupon);
                  break;
              case 2:
                  this.$.toToolCollect(template.id, 2, 1, this.userInfo.id);
                  exe(template, replace);
                  break;
              case 3:
                  if (this.$store.getters["isPoor"]) {
                      // hasUsableCoupon ? this.visibleCoupon = true : showPaypanel(template);
                      this.showPaypanel(template, hasUsableCoupon);
                      return;
                  }
                  this.$.toToolCollect(template.id, 2, 1, this.userInfo.id);
                  exe(template, replace);
                  break;
              case 7:
                  this.showPaypanel(template, hasUsableCoupon);
                  break;
              default:
                  this.$.toToolCollect(template.id, 2, 1, this.userInfo.id);
                  exe(template, replace);
                  break;
          }
      },
      // 检查是否有指定类型的优惠券
      async checkUsableCoupon(type) {
          let {data} = await this.$axios.get("/api/user/coupon?type=1");
          if(data.code !== 200 || !data.data.length) return false;
          let arr = data.data.filter(coupon => coupon.goodsType === type);
          return arr.length;
      },
      //获得优惠券id
      selectTicketHdl(couponId, ticketName) {
          if (!couponId) {
              this.payvisible = true;
              return;
          }
          this.$confirm("是否使用模板兑换券?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
          }).then(async () => {
              let templateId = this.currentTemplate.id || (this.template || {}).id;
              const res = await this.$axios.get("/api/user/template/relation", {
                  params: {
                      isOrder: 1,
                      id: templateId,
                      couponId,
                  }
              });
              if (!res || !res.data || !res.data.code) {
                  this.$message({
                      message: "请求出错",
                      type: "info"
                  });
                  return;
              }
              if (res.data.code !== 200) {
                  this.$message({
                      message: res.data.msg,
                      type: "info"
                  });
                  return;
              }
              this.visibleCoupon = false;
              this.closePanel();
              // this.fromUwp ? this.uwpHdl() : window.location.href = window.location.origin + `/tool?template=${this.currentTemplate.id}`;
              this.$modal.show("openTemplate", {
                id: templateId
              });
              this.$bus.emit("template.payDone", templateId);
          }).catch(() => {
              let modals = $('.v-modal');
              let modal = modals.eq(modals.length - 1);
              modal.appendTo('.comp-dialogTicket');
          });
      },
      // uwp跳转过来的订单支付成功的处理
      uwpHdl() {
          this.$alert("已完成支付。</br></br>请返回Win10客户端进行后续操作。", "支付提示", {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
          });
      },
      closePanel() {
          this.$emit("input", false);
          clearInterval(this.timer);
          this.wechat = true;
          this.timerM = 5;
          this.timerS = 0;
          this.qrcode = "";
      },
      showPaypanel(template, couponUsable) {
          this.currentTemplate = template;
          couponUsable ? this.visibleCoupon = true : this.payvisible = true;

          // 神策埋点：购买模板。区分购买模板的触发页面
          let templateBuyNow2SensorBridge = () => {
              let source = "";
              const { query, name } = this.$route;
              if (name === "templates" && query.keyword) {
                  source = "模板广场-搜索";
              } else if (name === "templates") {
                  source = "模板广场-立即使用";
              }
              if (name === "templates-id") {
                  source = "模板详情页";
              }
              if (name === "export") {
                  source = "作品导出页面-推荐位";
              }

              this.$store.commit("sensors/templateBuyNow2Sensors", {
                  card: template,
                  source,
              });
          };
          templateBuyNow2SensorBridge();
      },
  }
};



// WEBPACK FOOTER //
// ./src/platformCode/trans-temp-type.js